import { CreateNewCampaignForm } from './create-new-campaign-form'

export const CreateNewCampaign = ({
  onCloseModal,
}: {
  onCloseModal: () => void
}) => {
  return <CreateNewCampaignForm onCloseModal={onCloseModal} />
}
